import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Task } from "../types/tasks";
import { BASE_URL, envConfig } from "../config";
// Define a service using a base URL and expected endpoints
export const tasksApi = createApi({
  reducerPath: "tasksApi",
  baseQuery: fetchBaseQuery({
    credentials: "include",
    baseUrl: BASE_URL + "tasks",
    prepareHeaders: (headers) => {
      headers.set("api-key", `${envConfig.API_KEY}`);
      return headers;
    },
  }),
  tagTypes: ["Tasks"],
  endpoints: (builder) => ({
    getTasks: builder.query<Task[], string>({
      query: () => `/`,
      providesTags: ["Tasks"],
    }),
    getRecentTasks: builder.query<Task[], string>({
      query: () => `/recent`,
      providesTags: ["Tasks"],
    }),
    updateTask: builder.mutation<Task, Task>({
      query: ({ _id, ...patch }) => ({
        url: `/${_id}`,
        method: "PATCH",
        body: patch,
      }),
      invalidatesTags: ["Tasks"],
    }),
    deleteTask: builder.mutation<{ success: boolean; _id: string }, string>({
      query: (_id) => ({
        url: `/${_id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Tasks"],
    }),
    createTask: builder.mutation<Task, Task>({
      query: ({ _id, ...task }) => ({
        url: `/`,
        method: "POST",
        body: task,
      }),
      invalidatesTags: ["Tasks"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetTasksQuery,
  useGetRecentTasksQuery,
  useUpdateTaskMutation,
  useCreateTaskMutation,
  useDeleteTaskMutation,
} = tasksApi;
